// @flow

import { type ServicesMap } from '../types';
import getServiceName from './getServiceName';

export default function getServiceNameFromApi(
  api: string,
  services: ServicesMap | {}
) {
  return getServiceName(services[api]);
}
